// Fixed prompts shown one-by-one while the gift receiver records their own
// life-story video messages, organized into three sections.
//
// Each prompt only carries the on-screen `question` text — the recorder
// derives any short label it needs internally. Section grouping is driven
// by category_name (the section title) on each clip.
//
// The recorder walks sections in order: section intro screen → record each
// question in that section → next section's intro → ... Each section's
// `title` is stored on every clip as its category_name so the receiver's
// library groups clips section-by-section.

export const receiverSections = [
  {
    title: 'Beginning',
    intro: 'Where it all started — the early years that shaped you.',
    questions: [
      { question: "Take us back to your childhood — what's one memory that still makes you smile?" },
      { question: "Share a 'first' that left a mark on you — a moment that changed how you saw the world." },
      { question: 'When you were young, what did you dream of becoming? What did you imagine your life would look like?' },
      { question: 'What was school like for you? A teacher, a friend, a moment that stuck with you — what comes to mind first?' },
    ],
  },

  {
    title: 'Hustle',
    intro: 'The grind, the wins, and what you built along the way.',
    questions: [
      { question: 'What were your college years (or the years just after school) like? Share a moment or person who shaped who you are today.' },
      { question: 'Walk us through your first job — what you did, who you worked with, and what you learned the hard way.' },
      { question: 'Have you ever built something from scratch — a business, a product, or an idea? Tell us that story.' },
      { question: "What's a skill you taught yourself, and how did you get good at it?" },
      { question: 'Tell us about a side project or hustle — something you chased outside of the day job.' },
    ],
  },

  {
    title: 'Love & Relationships',
    intro: "The people who've walked the journey with you.",
    questions: [
      { question: "Tell us about a friendship that's shaped you — the kind you can't imagine your life without." },
      { question: 'Share a story from your dating life — funny, sweet, or hard-earned wisdom.' },
      { question: "If you're married, or have been, share that journey — how you met, what you've learned, what holds it together." },
      { question: 'Share a family memory you carry with you — something that captures who they are to you.' },
    ],
  },
];

// Flat question list — used by GiftRecorder as the single `questions` seed.
// Index in this list maps 1:1 onto the recorder's slot index for the preset
// section prompts (anything beyond this length is a custom-added question).
export const receiverFlatQuestions = receiverSections.flatMap(
  (s) => s.questions,
);

// Section title for each preset slot, parallel to receiverFlatQuestions.
// Used by GiftRecorder to render the per-slot section heading and to group
// review cards by section. Custom-added slots (index >= length) have no
// section and are rendered as "Unsectioned".
export const receiverSlotSectionTitles = receiverSections.flatMap(
  (s) => s.questions.map(() => s.title),
);
